import {
  Document,
  Page,
  View,
  Text,
  StyleSheet,
  Image,
} from '@react-pdf/renderer';
import { store, useStore } from '../../../../app/stores/store';
import { useEffect } from 'react';
import agent from '../../../../app/api/agent';
import { getImageSrc } from '../../../../utils/ImageHelper';

interface RemarksRowProps {
  label: string;
  value?: string;
  IsSignName?: string;
}

const Internalstyles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding: 20,
    fontSize: 8,
    fontFamily: 'Helvetica',
    border: '1px solid #000',
    borderCollapse: 'collapse',
  },
  table: { width: '100%' },
  tableRow: { flexDirection: 'row' },
  tableCol: {
    textAlign: 'center',
    border: '1px solid black',
    borderTop: 'none',
    flex: 1,
    padding: 2.2,
  },
  tableCell: { fontSize: 8, color: '#000' },
  lGreyBg: { backgroundColor: '#c0c0c0' },
  textCenter: { textAlign: 'center' },

  // Header
  headerRow: { flexDirection: 'row', width: '100%' },
  headerCell: {
    flex: 1,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 10,
    padding: 6,
    border: '1px solid black',
  },
  headerRow1: { backgroundColor: '#FFC000' },
  headerRow2: { backgroundColor: '#D9D9D9' },
  headerRow3: { backgroundColor: '#7B7B7B', color: '#fff' },

  // Remarks
  RemarksTable: {
    width: '100%',
    border: '1px solid black',
    borderTop: 'none',
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  bold: { fontWeight: 'bold' },
  tableColSmall: {
    flex: 1,
    border: '1px solid black',
    borderTop: 'none',
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 2,
  },
  header: {
    backgroundColor: '#FFD700',
    textAlign: 'center',
    padding: 5,
    fontSize: 10,
    fontWeight: 'bold',
    borderTop: '1px solid black',
    borderLeft: '1px solid black',
    borderRight: '1px solid black',
    borderBottom: 'none',
  },
  subHeader: {
    backgroundColor: '#d9d9d9',
    textAlign: 'center',
    padding: 5,
    fontSize: 10,
    fontWeight: 'bold',
    borderTop: '1px solid black',
    borderLeft: '1px solid black',
    borderRight: '1px solid black',
    borderBottom: 'none',
  },
  sectionTitle: {
    backgroundColor: '#808080',
    color: 'white',
    padding: 4,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 10,
    borderTop: '1px solid black',
    borderLeft: '1px solid black',
    borderRight: '1px solid black',
    borderBottom: 'none',
  },
  row: {
    flexDirection: 'row',
    borderRight: '1px solid black',
  },
  TopCellKey: {
    flex: 2,
    // borderTop: "1px solid black",
    borderBottom: '1px solid black',
    borderLeft: '1px solid black',
    borderRight: 'none',
    borderCollapse: 'collapse',
    fontWeight: 'bold',
    padding: 2,
  },
  TopCellValue: {
    flex: 1,
    // borderTop: "1px solid black",
    borderBottom: '1px solid black',
    borderLeft: '1px solid black',
    borderRight: 'none',
    borderCollapse: 'collapse',
    fontWeight: 'bold',
    padding: 2,
  },
  BottomCellKey: {
    width: '170px',
    // borderTop: "1px solid black",
    borderBottom: '1px solid black',
    borderLeft: '1px solid black',
    borderRight: 'none',
    borderCollapse: 'collapse',
    fontWeight: 'bold',
    padding: 2,
  },
  BottomCellValue: {
    flex: 1,
    // borderTop: "1px solid black",
    borderBottom: '1px solid black',
    borderLeft: '1px solid black',
    borderRight: 'none',
    borderCollapse: 'collapse',
    fontWeight: 'bold',
    padding: 2,
  },
  LangCellValue: {
    width: '170px',
    // borderTop: "1px solid black",
    borderBottom: '1px solid black',
    borderLeft: '1px solid black',
    borderRight: 'none',
    borderCollapse: 'collapse',
    fontWeight: 'bold',
    padding: 2,
  },
  SourceCellValue: {
    fontSize: 7,
    borderBottom: '1px solid black',
    borderLeft: '1px solid black',
    borderRight: 'none',
    borderCollapse: 'collapse',
    fontWeight: 'bold',
    paddingRight: '35px',
    paddingLeft: '2px',
  },
  rightHeaderCellValue: {
    borderBottom: '1px solid black',
    borderLeft: '1px solid black',
    borderRight: 'none',
    borderCollapse: 'collapse',
    fontWeight: 'bold',
    paddingRight: '35px',
    paddingLeft: '2px',
  },
  checkboxRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  checkbox: {
    width: 9,
    height: 9,
    border: '1pt solid #000',
  },
  checked: {
    backgroundColor: '#000',
  },
});

// Ordered sections
const ELEMENT_ORDER: { key: string; label?: string }[] = [
  { key: 'ORIGINALLTOANDCLONELTO' },
  { key: 'CHECKLISTDELIVERABLES', label: 'CHECKLIST' },
  { key: 'SUBTITLES', label: 'SUBTITLES' },
  { key: 'ALL REPORTS', label: 'ALL REPORTS' },
  {
    key: 'Before & After Picture & Audio Restoration Clips',
    label: 'Before & After Picture & Audio Restoration Clips',
  },
  {
    key: 'Images from Picture Restoration',
    label: 'Images from Picture Restoration',
  },
];

const checklistHeader = ['CONTENT', 'ORIGINAL LTO (Y/N)', 'CLONE LTO (Y/N)'];

const LTOReport = ({ localElementData, isDualPDF }: { localElementData: any[], isDualPDF:boolean }) => {
  const { masteringStore } = useStore();

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [localElementData]);

  const fetchData = async () => {
    try {
      const response = await agent.viewPage.getParentMetaData({
        itemId: store?.activityStore?.selectedActivity?.id,
      });
      if (response && response.data) {
        masteringStore.LtoReportInfo = response.data;
      } else {
        console.warn('No data found in response:', response);
      }
    } catch (error) {
      console.error('Error fetching metadata:', error);
    }
  };

  const findValue = (name: string) =>
    masteringStore.LtoReportInfo?.find((x) => x.elementName === name)?.elementValue || '';

  const firstLTOList = () => (
    <>
      {/* Headers */}
      <Text style={Internalstyles.header}>LTO - QUALITY CHECK REPORT</Text>
      <Text style={Internalstyles.subHeader}>NFHM Restoration Project</Text>
      <Text style={Internalstyles.sectionTitle}>
        PICTURE VENDOR NAME: Prasad Corporation Pvt Ltd, Chennai
      </Text>

      {/* Rows */}
      <View style={Internalstyles.row}>
        {/* Left Side */}
        <View style={{ flex: 1, flexDirection: 'row' }}>
          <Text style={Internalstyles.BottomCellKey}>PROJECT TITLE</Text>
          <Text style={Internalstyles.BottomCellValue}>
            {findValue('Film_Title')}
          </Text>
        </View>

        {/* Right Side */}
        <View style={{ flex: 1, flexDirection: 'row' }}>
          <Text style={Internalstyles.BottomCellKey}>DIRECTOR</Text>
          <Text style={Internalstyles.BottomCellValue}>
            {findValue('Director')}
          </Text>
        </View>
      </View>

      <View style={Internalstyles.row}>
        {/* Left Side */}
        <View style={{ flex: 1, flexDirection: 'row' }}>
          <Text style={Internalstyles.BottomCellKey}>PROJECT ID/CODE</Text>
          <Text style={Internalstyles.BottomCellValue}>
            {findValue('UCCID')}
          </Text>
        </View>

        {/* Right Side */}
        <View style={{ flex: 1, flexDirection: 'row' }}>
          <Text style={Internalstyles.BottomCellKey}>
            YEAR OF RELEASE/PRODUCTION
          </Text>
          <Text style={Internalstyles.BottomCellValue}>
            {findValue('Film_Year')}
          </Text>
        </View>
      </View>

      <View style={Internalstyles.row}>
        <Text style={[Internalstyles.LangCellValue]}>LANGUAGE</Text>
        <Text style={[Internalstyles.BottomCellValue, { flex: 1 }]}>
          {findValue('Language')}
        </Text>
        <Text style={[Internalstyles.BottomCellKey, { width: '276px' }]}>
          TYPE:{' '}
          <View>
            <View style={Internalstyles.checkboxRow}>
              <Text style={{ marginRight: '20px' }}>
                <Image
                  src={
                    findValue('Type')?.toLowerCase()?.includes('feature')
                    ? '/assets/checkbox-Checked.png'
                    : '/assets/checkbox-uncheck.png'
                  }
                  style={[Internalstyles.checkbox]}
                />{' '}
                Feature{' '}
              </Text>
            </View>
            <View style={Internalstyles.checkboxRow}>
              <Text>
                <Image
                  src={
                    findValue('Type')?.toLowerCase()?.includes('shorts/documentary')
                      ? '/assets/checkbox-Checked.png'
                    : '/assets/checkbox-uncheck.png'
                  }
                  style={[Internalstyles.checkbox]}
                />{' '}
                Shorts/Documentary{' '}
              </Text>
            </View>
          </View>
        </Text>
      </View>

      <View style={Internalstyles.row}>
        <Text style={[Internalstyles.BottomCellKey]}>RESOLUTION</Text>
        <View
          style={[
            Internalstyles.BottomCellValue,
            { flexDirection: 'row', flexWrap: 'wrap' },
          ]}
        >
          <View style={Internalstyles.checkboxRow}>
            <Text>
              <Image
                src={
                  findValue('Resolution').includes('4K')
                    ? '/assets/checkbox-Checked.png'
                    : '/assets/checkbox-uncheck.png'
                }
                style={Internalstyles.checkbox}
              />{' '}
              4K{' '}
            </Text>
          </View>
          <View style={Internalstyles.checkboxRow}>
            <Text>
              <Image
                src={
                  findValue('Resolution').includes('2K')
                    ? '/assets/checkbox-Checked.png'
                    : '/assets/checkbox-uncheck.png'
                }
                style={Internalstyles.checkbox}
              />{' '}
              2K{' '}
            </Text>
          </View>
        </View>
      </View>

      <View style={Internalstyles.row}>
        <Text style={[Internalstyles.BottomCellKey]}>SOURCE DPX</Text>
        <View
          style={[
            Internalstyles.SourceCellValue,
            { flexDirection: 'row', flexWrap: 'wrap' },
          ]}
        >
          <View style={Internalstyles.checkboxRow}>
            <Text>
              <Image
                src={
                  findValue('Film Type')?.toLowerCase()?.includes('b & w')
                    ? '/assets/checkbox-Checked.png'
                    : '/assets/checkbox-uncheck.png'
                }
                style={[Internalstyles.checkbox, { width: 8, height: 8 }]}
              />{' '}
              B & W{' '}
            </Text>
          </View>
          <View style={Internalstyles.checkboxRow}>
            <Text>
              <Image
                src={
                  findValue('Film Type')?.toLowerCase()?.includes('colour')
                    ? '/assets/checkbox-Checked.png'
                    : '/assets/checkbox-uncheck.png'
                }
                style={[Internalstyles.checkbox, { width: 8, height: 8 }]}
              />{' '}
              COLOR{' '}
            </Text>
          </View>
          <View style={Internalstyles.checkboxRow}>
            <Text>
              <Image
                src={
                  '/assets/checkbox-uncheck.png'
                }
                style={[Internalstyles.checkbox, { width: 8, height: 8 }]}
              />{' '}
              LOG{' '}
            </Text>
          </View>
          <View style={Internalstyles.checkboxRow}>
            <Text>
              <Image
                src={
                  '/assets/checkbox-Checked.png'
                }
                style={[Internalstyles.checkbox, { width: 8, height: 8 }]}
              />{' '}
              LINEAR{' '}
            </Text>
          </View>
        </View>

        <Text style={Internalstyles.TopCellKey}>IMAGE ASPECT ***:</Text>
        <Text style={Internalstyles.rightHeaderCellValue}>
          {findValue('Aspect Ratio')}
        </Text>
      </View>

      <View style={Internalstyles.row}>
        <Text
          style={[Internalstyles.BottomCellKey, { paddingRight: '93.5px' }]}
        >
          BIT DEPTH
        </Text>
        <View
          style={[
            Internalstyles.BottomCellValue,
            { flexDirection: 'row', flexWrap: 'wrap' },
          ]}
        >
          <View style={Internalstyles.checkboxRow}>
            <Text>
              <Image
                src={
                  findValue('Bit Depth').includes('10')
                    ? '/assets/checkbox-Checked.png'
                    : '/assets/checkbox-uncheck.png'
                }
                style={Internalstyles.checkbox}
              />{' '}
              10 bit{' '}
            </Text>
          </View>
          <View style={Internalstyles.checkboxRow}>
            <Text>
              <Image
                src={
                  findValue('Bit Depth').includes('16')
                    ? '/assets/checkbox-Checked.png'
                    : '/assets/checkbox-uncheck.png'
                }
                style={Internalstyles.checkbox}
              />{' '}
              16 bit{' '}
            </Text>
          </View>
        </View>
      </View>

      <View style={Internalstyles.row}>
        <Text style={Internalstyles.BottomCellKey}>SOURCE DPX COLOR SPACE</Text>
        <Text style={Internalstyles.BottomCellValue}>
          {findValue('SOURCE DPX COLOR SPACE')}
        </Text>
      </View>

      <View style={Internalstyles.row}>
        <Text style={Internalstyles.BottomCellKey}>SOURCE DPX ORIGIN</Text>
        <Text style={Internalstyles.BottomCellValue}>
          {findValue('Film Gauge')}
        </Text>
      </View>

      <View style={Internalstyles.row}>
        <Text style={Internalstyles.BottomCellKey}>SOURCE AUDIO FORMAT</Text>
        <Text style={Internalstyles.BottomCellValue}>
          {findValue('SOURCE AUDIO FORMAT')}
        </Text>
      </View>

      <View style={Internalstyles.row}>
        <Text style={Internalstyles.BottomCellKey}>NO. OF REELS</Text>
        <Text style={Internalstyles.BottomCellValue}>
          {findValue('Total Reels')}
        </Text>
      </View>

      <View style={Internalstyles.row}>
        <Text style={Internalstyles.BottomCellKey}>
          DURATION (Synced Title in Mins)
        </Text>
        <Text style={Internalstyles.BottomCellValue}>
          {findValue('Duration (Synced Title in Mints)')}
        </Text>
      </View>

      <View style={Internalstyles.row}>
        <Text style={Internalstyles.BottomCellKey}>
          PICTURE RESTORATION VENDOR NAME
        </Text>
        <Text style={Internalstyles.BottomCellValue}>
          {findValue('PICTURE RESTORATION VENDOR NAME')}
        </Text>
      </View>

      <View style={Internalstyles.row}>
        <Text style={Internalstyles.BottomCellKey}>
          AUDIO RESTORATION VENDOR NAME
        </Text>
        <Text style={Internalstyles.BottomCellValue}>
          {findValue('AUDIO RESTORATION VENDOR NAME')}
        </Text>
      </View>

      <View style={Internalstyles.row}>
        <Text style={Internalstyles.BottomCellKey}>LTO CREATION DATE</Text>
        <Text style={Internalstyles.BottomCellValue}>
          {findValue('LTO CREATION DATE')?.replace(/\//g, '-')}
        </Text>
      </View>

      <View style={Internalstyles.row}>
        <Text style={Internalstyles.BottomCellKey}>
          LTO CLONE CREATION DATE
        </Text>
        <Text style={Internalstyles.BottomCellValue}>
          {findValue('LTO CLONE CREATION DATE')?.replace(/\//g, '-')}
        </Text>
      </View>
    </>
  );

  // Render QC tables dynamically
  const renderQCRows = (elementName: string) => {
    const found = masteringStore.LtoReportInfo?.find((e) => e.elementName === elementName);
    if (!found || !found.elementValue) return <></>;

    let data: any[] = [];
    try {
      data = JSON.parse(found.elementValue?.split('DynamicTable|')[1]);
    } catch (e) {
      console.error('JSON parsing error for elementValue:', e);
      return <></>;
    }

    if (!Array.isArray(data) || data.length === 0) return <></>;

    const firstHeaders = ['Description', 'ORIGINAL LTO', 'CLONE LTO'];

    return (
      <>
        {/* Special Header for LTO Clones */}
        {elementName === 'ORIGINALLTOANDCLONELTO' ? (
          <View style={Internalstyles.tableRow}>
            {(firstHeaders || [])?.map((x, i) => (
              <View
                key={i}
                style={[
                  Internalstyles.tableCol,
                  Internalstyles.lGreyBg,
                  Internalstyles.textCenter,
                  { borderRight: i === 2 ? '1px solid black' : '' },
                ]}
              >
                <Text style={Internalstyles.tableCell}>{x}</Text>
              </View>
            ))}
          </View>
        ) : null}
        {/* Data Rows */}
        {(Array.isArray(data) ? data.slice(0, 23) : [])?.map((row: any, i: number) => (
          <View style={Internalstyles.tableRow} key={i}>
            <View style={[Internalstyles.tableCol, { borderRight: 'none' }]}>
              <Text style={Internalstyles.tableCell}>
                {row?.['Description']
                  ? row?.['Description']
                  : row?.['CONTENT']
                    ? row?.['CONTENT']
                    : ''}
              </Text>
            </View>
            <View style={[Internalstyles.tableCol, { borderRight: 'none' }]}>
              <Text style={Internalstyles.tableCell}>
                {row?.['ORIGINAL LTO']
                  ? row?.['ORIGINAL LTO']
                  : row?.['ORIGINAL LTO (Y/N)']
                    ? row?.['ORIGINAL LTO (Y/N)']
                    : ''}
              </Text>
            </View>
            <View style={Internalstyles.tableCol}>
              <Text style={Internalstyles.tableCell}>
                {row?.['CLONE LTO']
                  ? row?.['CLONE LTO']
                  : row?.['CLONE LTO (Y/N)']
                    ? row?.['CLONE LTO (Y/N)']
                    : ''}
              </Text>
            </View>
          </View>
        ))}
    {isDualPDF && elementName === "CHECKLISTDELIVERABLES" ? 
    <View style={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'flex-end', padding: 5, marginTop: '5px' }}>
                <Image 
                  src={getImageSrc('bala')} 
                  style={{ width: 70, height: 40, marginBottom: 80 }} 
                />
              </View> : null}
        {(Array.isArray(data) ? data.slice(23) : [])?.map((row: any, i: number) => (
          <View style={Internalstyles.tableRow} key={i}>
            <View style={[Internalstyles.tableCol, { borderRight: 'none' }]}>
              <Text style={Internalstyles.tableCell}>
                {row?.['Description']
                  ? row?.['Description']
                  : row?.['CONTENT']
                    ? row?.['CONTENT']
                    : ''}
              </Text>
            </View>
            <View style={[Internalstyles.tableCol, { borderRight: 'none' }]}>
              <Text style={Internalstyles.tableCell}>
                {row?.['ORIGINAL LTO']
                  ? row?.['ORIGINAL LTO']
                  : row?.['ORIGINAL LTO (Y/N)']
                    ? row?.['ORIGINAL LTO (Y/N)']
                    : ''}
              </Text>
            </View>
            <View style={Internalstyles.tableCol}>
              <Text style={Internalstyles.tableCell}>
                {row?.['CLONE LTO']
                  ? row?.['CLONE LTO']
                  : row?.['CLONE LTO (Y/N)']
                    ? row?.['CLONE LTO (Y/N)']
                    : ''}
              </Text>
            </View>
          </View>
        ))}
      </>
    );
  };

  // Remarks Rows
  const RemarksRow = ({ label, value, IsSignName }: RemarksRowProps) => {
    const cleanName = IsSignName?.toLowerCase().trim().replace(/\s+/g, '');
    let imagePath = '';
    
    if (cleanName?.replaceAll(' ','')?.includes('arulkumar')) {
      imagePath = getImageSrc('arulkumar');
    } else if (cleanName?.includes('riaz khan')) {
      imagePath = getImageSrc('riaz khan');
    } else if (cleanName?.includes('siddharth')) {
      imagePath = getImageSrc('siddharth');
    } else if (cleanName?.includes('kalai')) {
      imagePath = getImageSrc('kalai');
    } else if (cleanName?.includes('karthick')) {
      imagePath = getImageSrc('karthick');
    } else if (cleanName?.includes('rajan')) {
      imagePath = getImageSrc('rajan');
    } else if (cleanName?.includes('pramodvarma') || cleanName?.includes("promodvarma")) {
      imagePath = getImageSrc('pramod');
    }
    return (
      <View style={Internalstyles.tableRow}>
        {/* Label cell */}
        <View
          style={[
            Internalstyles.tableCol,
            { borderRightWidth: 0, borderLeftWidth: 0 },
          ]}
        >
          <Text style={Internalstyles.bold}>{label}</Text>
        </View>

        {/* Value cell */}
        <View style={Internalstyles.tableCol}>
          <View>
            {imagePath ? (
              <Text>
                <Image
                  src={imagePath}
                  style={{
                    width: 120,
                    height: `${cleanName?.replaceAll(' ','')?.includes('arulkumar') ? 40 : cleanName?.includes('pramodvarma') || cleanName?.includes("promodvarma")  ? 50 : 70}`,
                  }}
                />
              </Text>
            ) : null}
            <Text>{value || ''}</Text>
          </View>
        </View>
      </View>
    );
  };

  const remarksRender = (
    <View style={Internalstyles.RemarksTable}>
      <View style={Internalstyles.tableRow}>
        <View
          style={[Internalstyles.tableColSmall, { width: 300, minHeight: 30 }]}
        >
          <Text style={Internalstyles.bold}>
            SPECIAL/ ADDITIONAL REMARKS:{' '}
            {findValue('SPECIAL/ ADDITIONAL REMARKS BY NFHM QC SUPERVISOR')}
          </Text>
        </View>
      </View>
      <RemarksRow
        label="VENDOR SUPERVISOR NAME"
        value={findValue('VENDOR SUPERVISOR NAME')}
      />
      <RemarksRow
        label="SIGNATURE & DATE"
        value={findValue('VENDOR SUPERVISOR NAME SIGNATURE & DATE')}
        IsSignName={findValue('VENDOR SUPERVISOR NAME') || ''}
      />
      <RemarksRow
        label="QUALITY CHECKED BY NFHM/ NFDC-NFAI"
        value={findValue('QUALITY CHECKED BY NFHM/NFDC-NFAI')}
      />
      <RemarksRow
        label="SIGNATURE & QC DATE"
        value={findValue(
          'QUALITY CHECKED BY NFHM/NFDC-NFAI SIGNATURE & QC DATE',
        )}
        IsSignName={findValue('QUALITY CHECKED BY NFHM/NFDC-NFAI') || ''}
      />
      <View style={Internalstyles.tableRow}>
        <View style={[Internalstyles.tableColSmall, { minHeight: 10 }]}>
          <Text style={Internalstyles.bold}>
            **** Sound films should have Aspect Ratio 1.37 and not 1.33
          </Text>
        </View>
      </View>
    </View>
  );

  return (
    <Document>
      <Page size="A4" style={Internalstyles.page}>
        {firstLTOList()}
        {/* QC Ordered Sections */}
        {(ELEMENT_ORDER || [])?.map(({ key, label }, idx) => (
          <View key={idx} style={Internalstyles.table}>
            {label ? (
              <View style={Internalstyles.tableRow}>
                <View style={[Internalstyles.tableCol, Internalstyles.lGreyBg]}>
                  <Text
                    style={[
                      Internalstyles.tableCell,
                      Internalstyles.textCenter,
                    ]}
                  >
                    {label}
                  </Text>
                </View>
              </View>
            ) : null}
            {key === 'CHECKLISTDELIVERABLES' ? (
              <>
                <View style={Internalstyles.tableRow}>
                  {(checklistHeader || [])?.map((x, i) => (
                    <View
                      key={i}
                      style={[
                        Internalstyles.tableCol,
                        Internalstyles.lGreyBg,
                        Internalstyles.textCenter,
                        { borderRight: i === 2 ? '1px solid black' : '' },
                      ]}
                    >
                      <Text
                        style={[
                          Internalstyles.tableCell,
                          { borderRight: 'none' },
                        ]}
                      >
                        {x}
                      </Text>
                    </View>
                  ))}
                </View>
                <View style={Internalstyles.tableRow}>
                  <View
                    style={[Internalstyles.tableCol, Internalstyles.lGreyBg]}
                  >
                    <Text
                      style={[
                        Internalstyles.tableCell,
                        Internalstyles.textCenter,
                      ]}
                    >
                      DELIVERABLES
                    </Text>
                  </View>
                </View>
              </>
            ) : null}
            {renderQCRows(key)}
          </View>
        ))}

        {remarksRender}
        {isDualPDF ? 
    <View style={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                <Image 
                  src={getImageSrc('bala')} 
                  style={{ width: 65, height: 35, marginTop: 20 }} 
                />
              </View> : null}
      </Page>
    </Document>
  );
};

export default LTOReport;